module.exports = __webpack_public_path__ + "img/alert-modal.dd7aaa3d.svg";